import { connect } from 'react-redux'
import { IStoreState, IServiceLocationObject } from '../../types/index'
import * as serviceActions from '../../state/actions/services'
import ServiceEditSuggestedLocations from 'src/components/services/edit/ServiceEditSuggestedLocations'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  const { serviceId } = ownProps

  return {
    serviceId,
    suggestedLocationList: state.service.locationList,
    zoom: state.mapView.zoom,
    bounds: state.mapView.bounds
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getSuggestedLocationList: (serviceId: string): any => {
      return dispatch(serviceActions.getSuggestedLocationList(serviceId))
    },
    saveLocation: (location: IServiceLocationObject) => {
      return dispatch(serviceActions.updateSuggestedLocation(location))
    },
    createLocation: (serviceId: string, location: IServiceLocationObject): Promise<any> => {
      return dispatch(serviceActions.createSuggestedLocation(serviceId, location))
    },
    deleteLocation: (id: string): Promise<any> => {
      return dispatch(serviceActions.deleteSuggestedLocation(id))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceEditSuggestedLocations)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceEditSuggestedLocations.ts